// src/app/modules/Events/pages/EventsList.jsx
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CalendarDays, Plus, ChevronRight, Search, Filter } from 'lucide-react';
import * as actions from '../../Dashbord/_redux/dashboard/Actions';
import './events.scss';

const STATUS_FILTERS = ['all', 'draft', 'published', 'ended', 'cancelled'];
const statusColor = { draft: '#94A3B8', published: '#16A34A', cancelled: '#DC2626', ended: '#6B7280' };
const statusBg    = { draft: '#F1F5F9', published: '#DCFCE7', cancelled: '#FEE2E2', ended: '#F3F4F6' };

export function EventsList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { org } = useSelector(s => ({ org: s.auth.organization }), shallowEqual);
  const { events } = useSelector(s => ({ events: s.dashboard.events }), shallowEqual);

  const [search, setSearch]     = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    if (!org) return;
    const params = { limit: 50 };
    if (statusFilter !== 'all') params.status = statusFilter;
    if (search) params.search = search;
    dispatch(actions.fetchAllData('events', org.organization_id, params));
  }, [org, statusFilter, search]);

  return (
    <div className="ev-page">
      <div className="ev-page__header">
        <div>
          <h1 className="ev-page__title">Events</h1>
          <p className="ev-page__sub">Manage all your events</p>
        </div>
        <button className="ev-btn ev-btn--primary" onClick={() => navigate('/events/new')}>
          <Plus size={15} strokeWidth={2} /> Create Event
        </button>
      </div>

      {/* Filters */}
      <div className="ev-filters">
        <div className="ev-search">
          <Search size={14} strokeWidth={1.8} color="#9597A6" />
          <input
            placeholder="Search events..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div className="ev-tabs">
          {STATUS_FILTERS.map(s => (
            <button
              key={s}
              className={`ev-tab ${statusFilter === s ? 'active' : ''}`}
              onClick={() => setStatusFilter(s)}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="ev-list">
        {(!events || events.length === 0) && (
          <div className="ev-empty">
            <CalendarDays size={32} strokeWidth={1.4} />
            <p>No events found.</p>
            <button className="ev-btn ev-btn--primary" onClick={() => navigate('/events/new')}>
              <Plus size={14} /> Create Event
            </button>
          </div>
        )}
        {events?.map(ev => (
          <div className="ev-row" key={ev.event_id} onClick={() => navigate(`/events/${ev.event_id}`)}>
            <div className="ev-row__info">
              <span className="ev-row__name">{ev.name}</span>
              <span className="ev-row__date">
                {ev.start_date ? new Date(ev.start_date).toLocaleDateString('en-NG', { day: 'numeric', month: 'short', year: 'numeric' }) : '—'}
                {ev.venue ? ` · ${ev.venue}` : ''}
              </span>
            </div>
            <div className="ev-row__right">
              <span className="ev-badge" style={{ background: statusBg[ev.status] || '#F1F5F9', color: statusColor[ev.status] || '#52546A' }}>
                {ev.status || 'draft'}
              </span>
              <span className="ev-row__tickets">{ev.tickets_sold ?? 0} sold</span>
              <span className="ev-row__rev">
                {ev.revenue ? `₦${Number(ev.revenue).toLocaleString()}` : '—'}
              </span>
              <ChevronRight size={14} strokeWidth={1.8} color="#CACCD8" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
